import { getData, overwrite } from 'country-list'

import { Country } from 'hooks/retailer/use-countries'

overwrite([
  {
    code: 'TW',
    name: 'Taiwan',
  },
  {
    code: 'VN',
    name: 'Vietnam',
  },
])

export const countries = getData().sort((country1, country2) => {
  const textA = country1.name.toUpperCase()
  const textB = country2.name.toUpperCase()
  return textA < textB ? -1 : textA > textB ? 1 : 0
})

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getTranslatedServerSideCountries = (countries: Country[], translation: Record<string, string>) => {
  const updatedCountries = countries.map((country) => {
    let translated = country.name
    // Disabled in MAR-2705
    // let translated = translation[country.name] || country.name
    if (translated === 'Hong Kong') {
      translated = 'Hong Kong SAR'
    }
    return { id: country.id, name: translated, countryCode: country.countryCode }
  })
  return updatedCountries.sort((a, b) => a.name.localeCompare(b.name))
}

export const getTranslatedServerSideLanguages = (
  languages: [Record<string, string>],
  translation: Record<string, string>
) => {
  return languages
  // Disabled in MAR-2705
  const updatedLanguages = languages.map((language) => {
    const translated = translation[language.name] || language.name
    return { id: language.id, name: translated }
  })
  return updatedLanguages
}
